import IncorrectIcon from '@ingka/ssr-icon/paths/incorrect';
import { useServiceSettings } from 'contexts/serviceSettings';
import { useTranslations } from 'hooks/useTranslations';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import media from 'ui/media';
import { adjustMeasurementsSystem } from 'utils/adjustMeasurementsSystem';

const Wrapper = styled.div`
  padding: 0 0 ${({ theme }) => theme.space.md};
  ${media.mobile`
   padding: 1.5rem 1.5rem 0 1.5rem;
  `};
`;

const CeilingHeightInfoMessage = () => {
  const { formatMessage } = useIntl();
  const { unit, useMetric } = useTranslations();
  const { translations } = useServiceSettings();

  const height = adjustMeasurementsSystem(2400, translations, useMetric);

  const infoMessage = {
    message: 'storageone.ceilingHeightLoftBedInfoMessage',
    params: { height, unit }
  };

  return (
    <Wrapper>
      <SkapaInlineMessage
        title={formatMessage({ id: 'storageone.lowCeilingHeightInfoHeading' })}
        body={formatMessage({ id: infoMessage.message }, infoMessage.params)}
        variant={InlineMessageVariantEnum.NEGATIVE}
        subtle={false}
        ssrIcon={IncorrectIcon}
      />
    </Wrapper>
  );
};
export default CeilingHeightInfoMessage;
